// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"cd2a9ffd524e06d0c9f5","293":"27c13283d2147d3a3dac"}[chunkId] + ".js";
};